export interface SaleResponseInfo {
	parentTransactionId: string;
	amount: number;
	tenders: {
		ewallet?: number;
		cash?: number;
		stf?: number;
		sd?: number;
		credit?: number;
		check?: number;
		po?: number;
	};
	maskedCard?: string;
	cardType?: string;
}

export const defaultSaleResponseInfo: SaleResponseInfo = {
	parentTransactionId: '',
	amount: 0,
	tenders: {},
};
